import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { AppState } from './../../../../App.state';
import { NovoDashboardService } from 'src/app/base/services/novo-dashboard.service';
import { DialogService } from 'src/app/global/services/dialog.service';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { VolumeCreditoMensal } from 'src/app/base/domain/dto/volume-credito-mensal.dto';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard-volume-credito-mensal',
  templateUrl: './dashboard-volume-credito-mensal.component.html',
  styleUrls: ['./dashboard-volume-credito-mensal.component.css']
})
export class DashboardVolumeCreditoMensalComponent implements OnInit {

  @ViewChild('graficoVolumeCreditoMensal', { static: true })
  canvas!: ElementRef<HTMLCanvasElement>;

  estado = '';
  dataInicio = '';
  dataFim = '';

  evolucaoMensal: VolumeCreditoMensal[] = [];
  chart?: Chart;

  totalOperacoes = 0;
  totalVolume = 0;
  ticketMedioGeral = 0;

  constructor(
    private service: NovoDashboardService,
    private appState: AppState,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadDashboard();
  }

  loadDashboard(): void {
    this.appState.isLoading = true;

    const params: { [key: string]: string } = {};
    if (this.estado) { params.estado = this.estado; }
    if (this.dataInicio) { params.dataInicio = this.dataInicio; }
    if (this.dataFim) { params.dataFim = this.dataFim; }

    this.service.findAllVolumeCreditoMensal(new QueryOptions({ params })).subscribe({
      next: (response) => {
        this.evolucaoMensal = response;
        this.calcularTotais();
        this.createChart();
        this.appState.isLoading = false;
      },
      error: () => {
        this.dialogService.feedbackError('Erro ao carregar o volume de crédito mensal.');
        this.appState.isLoading = false;
      }
    });
  }

  private calcularTotais(): void {
    this.totalOperacoes = this.evolucaoMensal.reduce((soma, item) => soma + (item.operacoes || 0), 0);
    this.totalVolume = this.evolucaoMensal.reduce((soma, item) => soma + (item.valorTotal || 0), 0);
    this.ticketMedioGeral = this.totalOperacoes > 0 ? this.totalVolume / this.totalOperacoes : 0;
  }

  private createChart(): void {
    if (this.chart) {
      this.chart.destroy();
    }

    const labels = this.evolucaoMensal.map(item => item.mes);

    this.chart = new Chart(this.canvas.nativeElement, {
      data: {
        labels,
        datasets: [
          {
            type: 'bar',
            label: 'Operações',
            data: this.evolucaoMensal.map(item => item.operacoes),
            backgroundColor: '#66bb6a',
            borderRadius: 6,
            yAxisID: 'yOperacoes'
          },
          {
            type: 'line',
            label: 'Volume Liberado (R$)',
            data: this.evolucaoMensal.map(item => item.valorTotal),
            borderColor: '#42a5f5',
            backgroundColor: 'rgba(66,165,245,0.15)',
            fill: true,
            tension: 0.3,
            yAxisID: 'yVolume'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yVolume: {
            type: 'linear',
            position: 'left',
            beginAtZero: true,
            title: { display: true, text: 'Volume Liberado (R$)' }
          },
          yOperacoes: {
            type: 'linear',
            position: 'right',
            beginAtZero: true,
            grid: { drawOnChartArea: false },
            title: { display: true, text: 'Operações' }
          }
        }
      }
    });
  }
}
